export default __webpack_public_path__ + "static/media/525.b316f120.jpg";